const words = [
  {
    id: 'doll',
    word: 'Doll',
    label: 'Can you say… DOLL?',
  },
  {
    id: 'balloon',
    word: 'Balloon',
    label: 'Can you say… BALLOON?',
  },
  {
    id: 'ball',
    word: 'Ball',
    label: 'Can you say… BALL?',
  },
  {
    id: 'teddybear',
    word: 'Teddy Bear',
    label: 'Can you say… TEDDY BEAR?',
  },
];

export default words;
